if (!customElements.get("variant-options")) {
  customElements.define(
    "variant-options",
    class VariantOptions extends HTMLElement {
      whenLoaded = Promise.all([customElements.whenDefined("gallery-section")]);
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
        this.addEventListener("keydown", this.onKeyDown);

        this.container = document.querySelector(
          `section[data-product-handle="${this.getAttribute("data-product-handle")}"]`,
        );
      }

      connectedCallback() {
        this.whenLoaded.then(() => {
          this.initialize();
        });
      }

      disconnectedCallback() {
        this.productInfoController?.abort();
        this.productInfoController = null;
      }

      initialize() {
        this.updateOptions();
        this.updateMasterId();
        if (this.currentVariant) this.updateVariantInput();
        this.updateGallery();
        this.updateVariantStatuses();
        this.updateDropdownButtons();
      }

      onKeyDown(event) {
        if (event.key === "Enter" || event.keyCode === 13) {
          const input = event.target.querySelector("input");
          input?.click();
          // this.onVariantChange();
        }
      }

      onVariantChange(event) {
        const variantChangeStartEvent = new CustomEvent("variantChangeStart", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeStartEvent);
        this.updateOptions();
        this.updateMasterId();
        if (!this.currentVariant) this.resolveOrganizerSelection(event);
        this.updateGallery();
        this.toggleAddButton(true, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();
        this.updateDropdownButtons();

        if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
          this.setUnavailable();
        } else {
          this.updateMedia();
          this.lenOfVariantOptions =
            document.querySelectorAll("variant-options").length;
          if (this.lenOfVariantOptions === 1) {
            this.updateURL();
          }
          this.updateVariantInput();
          this.renderProductInfo();
          this.updateShareUrl();
        }
        const variantChangeEndEvent = new CustomEvent("variantChangeEnd", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeEndEvent);
      }

      resolveOrganizerSelection(event) {
        const handle = this.getAttribute("data-product-handle");
        const organizer = document.querySelector('rok-organizer-catalog[data-product-handle="' + handle + '"], rok-organizer-details[data-product-handle="' + handle + '"]');
        if (!organizer) return;
        const fieldsets = Array.from(this.querySelectorAll(".wt-product__option"));
        const changedIndex = fieldsets.findIndex(fieldset => fieldset.contains(event?.target));
        if (changedIndex < 0) return;
        const candidates = this.getVariantData().filter(variant => variant.options[changedIndex] === this.options[changedIndex]);
        const score = variant => variant.options.reduce((total, value, index) => total + (value === this.options[index] ? 1 : 0), 0);
        candidates.sort((a, b) => score(b) - score(a));
        const chosen = candidates[0];
        if (!chosen) return;
        fieldsets.forEach((fieldset, index) => {
          fieldset.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === chosen.options[index]; });
        });
        this.updateOptions();
        this.updateMasterId();
      }

      updateGallery() {
        const mediaGallery = document.getElementById(
          `MediaGallery-${this.dataset.section}`,
        );

        let media_id = false;
        if (this.currentVariant && this.currentVariant.featured_media) {
          media_id = this.currentVariant.featured_media.id;
        }

        mediaGallery?.filterSlides(this.options, media_id, true);
      }

      updateDropdownButtons(){
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          )?.value || '';
        });

        fieldsets.forEach((fieldset) => {
          const dropdown = fieldset.querySelector(
            ".wt-product__option__dropdown",
          );
          if (dropdown) {
            const checkedInput = fieldset.querySelector('fieldset input:checked')
            if(!checkedInput) return
            const isInputDisabled = checkedInput?.classList.contains('disabled')
            dropdown.classList.toggle('wt-product__option__dropdown--unavailable', isInputDisabled)
          }
        });
      }

      updateOptions() {
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        this.options = fieldsets.map((fieldset) => {
          return (
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked,
            )?.value || ""
          );
        });

        this.checkedOptions = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          ) || '';
        });

        fieldsets.forEach((fieldset, index) => {
          const selectedOption = this.options[index];

          if (!selectedOption) return;

          fieldset.querySelector(
            ".wt-product__option__title .value",
          ).innerHTML = selectedOption;
          const dropdownSpan = fieldset.querySelector(
            ".wt-product__option__dropdown span",
          );
          if (dropdownSpan) dropdownSpan.innerHTML = selectedOption;
        });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData()?.find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateMedia() {
        if (!this.currentVariant) return;
        this.setAttribute("data-variant-id", this.currentVariant?.id);
        if (!this.currentVariant.featured_media) return;
        this.setAttribute(
          "data-featured-image",
          this.currentVariant?.featured_media?.preview_image?.src,
        );
        this.setAttribute(
          "data-featured-image-id",
          this.currentVariant?.featured_media?.id,
        );

        const modalContent = document.querySelector(
          `#ProductModal-${this.dataset.section} .product-media-modal__content`,
        );
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(
          `[data-media-id="${this.currentVariant.featured_media.id}"]`,
        );
        modalContent.prepend(newMediaModal);
      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }

      updateShareUrl() {
        const shareButton = document.getElementById(
          `Share-${this.dataset.section}`,
        );
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          if (!input || !this.currentVariant) return;
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateVariantStatuses() {
        // const selectedOptionOneVariants = this.variantData.filter(
        //   (variant) => this.querySelector(':checked').value === variant.option1
        //   );
        const selectedOptionOneVariants = this.variantData?.filter(
          (variant) => variant.available === true,
        );
        const inputWrappers = [
          ...this.querySelectorAll(".product-form__input"),
        ];
        inputWrappers.forEach((option, index) => {
          if (index === 0 && this.currentVariant?.options.length > 1) return;
          const optionInputs = [
            ...option.querySelectorAll('input[type="radio"], option'),
          ];
          const previousOptionSelected =
            inputWrappers[index - 1]?.querySelector(":checked")?.value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter(
              (variant) =>
                variant.available &&
                variant[`option${index}`] === previousOptionSelected,
            )
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
          if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
            input.classList.remove("disabled");
          } else {
            input.classList.add("disabled");
          }
        });
      }

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector(
          "pickup-availability",
        );
        if (!pickUpAvailability) return;

        pickUpAvailability.dataset.variantId = this.currentVariant?.id;
        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute("available");
          pickUpAvailability.innerHTML = "";
        }
      }

      removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        try {
          productForm?.handleErrorMessage();
        } catch (err) {
          console.log(err);
        }
      }

      async renderProductInfo() {
        const requestedVariantId = this.currentVariant?.id;
        if (!requestedVariantId) return;
        this.productInfoController?.abort();
        const controller = new AbortController();
        this.productInfoController = controller;
        const sectionId = this.dataset.originalSection || this.dataset.section;
        const productUrl = new URL(this.dataset.url, window.location.origin);
        productUrl.searchParams.set("variant", requestedVariantId);
        const previewThemeId = new URL(window.location.href).searchParams.get("preview_theme_id");
        if (previewThemeId) productUrl.searchParams.set("preview_theme_id", previewThemeId);
        const sectionUrl = new URL(productUrl);
        sectionUrl.searchParams.set("section_id", sectionId);
        const timeout = setTimeout(() => controller.abort(), 10000);
        const isCurrent = () =>
          this.productInfoController === controller &&
          this.currentVariant?.id === requestedVariantId;

        try {
          const response = await fetch(sectionUrl.toString(), { signal: controller.signal });
          if (!response.ok) throw new Error("Product section request failed");
          const responseText = await response.text();
          if (!isCurrent()) return;

          const html = new DOMParser().parseFromString(responseText, "text/html");
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const source = html.getElementById(`price-${sectionId}`);
          const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
          const skuSource = html.getElementById(`Sku-${sectionId}`);
          const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
          const inventorySource = html.getElementById(`Inventory-${sectionId}`);
          const addButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
          const variantInput = html.getElementById(`product-form-${sectionId}`)?.querySelector('input[name="id"]');
          const buttonText = addButtonUpdated?.querySelector("span")?.textContent?.trim();

          if (
            (destination && !source) ||
            (skuDestination && !skuSource) ||
            (inventoryDestination && !inventorySource) ||
            (addButton && (!addButtonUpdated || !buttonText || String(variantInput?.value) !== String(requestedVariantId)))
          ) {
            throw new Error("Incomplete product section response");
          }

          if (source && destination) destination.innerHTML = source.innerHTML;
          if (inventorySource && inventoryDestination) {
            inventoryDestination.innerHTML = inventorySource.innerHTML;
            inventoryDestination.classList.toggle("visibility-hidden", inventorySource.innerText === "");
          }
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle("visibility-hidden", skuSource.classList.contains("visibility-hidden"));
          }
          if (destination) destination.classList.remove("visibility-hidden");
          if (addButtonUpdated) {
            this.toggleAddButton(addButtonUpdated.hasAttribute("disabled"), buttonText);
          }

          const gallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
          const selectedMedia = html.querySelector("[data-rok-selected-sku-media]");
          const galleryMedia = gallery?.querySelector("[data-rok-selected-sku-media]");
          if (selectedMedia && galleryMedia) {
            galleryMedia.textContent = selectedMedia.textContent;
            gallery.filterSlides(this.currentVariant.options, this.currentVariant.featured_media?.id || false, true);
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: { sectionId, html, variant: this.currentVariant },
          });
        } catch (error) {
          if (isCurrent()) window.location.assign(productUrl.toString());
        } finally {
          clearTimeout(timeout);
          if (this.productInfoController === controller) this.productInfoController = null;
        }
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (addButtonText) addButton.setAttribute("aria-label", addButtonText.textContent.trim());

        if (!modifyClass) return;
      }

      setUnavailable() {
        const button = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("visibility-hidden");
        if (inventory) inventory.classList.add("visibility-hidden");
        if (sku) sku.classList.add("visibility-hidden");
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent,
          );
        return this.variantData;
      }
    },
  );
}
// customElements.define('variant-options', VariantOptions);


